var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 50,
    viewBox: "0 0 32 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78271 8.6084L25.2147 13.5084V42.9084L6.78271 33.8084V8.6084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1904 10.9479C24.3648 11.3559 23.5379 11.7619 22.7149 12.1699L6.80957 4.69788C7.74141 4.27388 8.67069 3.84588 9.60253 3.42188C14.7993 5.92988 19.9961 8.43988 25.1904 10.9479Z",
    fill: "#FDB86D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1904 10.9482V44.1142L22.7148 46.3983V12.1702L25.1904 10.9482Z",
    fill: "#FB861B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80957 4.7002V37.7502L22.7149 46.4002V12.1722C17.4118 9.68219 12.1126 7.1882 6.80957 4.7002ZM8.77693 34.2042V30.3522C9.11357 30.5462 11.1372 31.5362 13.4092 32.6462L13.4285 36.4982C11.1462 35.3922 9.10973 34.3982 8.77693 34.2042ZM20.439 31.0242C19.6569 30.5722 9.55901 25.7402 8.77693 25.2862V21.4342C9.57181 21.9022 19.6812 26.7482 20.471 27.2102C20.4608 28.4822 20.4492 29.7522 20.439 31.0242ZM20.439 25.7882C19.6569 25.3342 9.55901 20.5042 8.77693 20.0502V16.1962C9.57181 16.6642 19.6812 21.5102 20.471 21.9722C20.4608 23.2442 20.4492 24.5142 20.439 25.7862V25.7882ZM20.439 20.8642C19.6569 20.4102 9.55901 15.5802 8.77693 15.1262V11.2742C9.57181 11.7362 19.6812 16.5882 20.471 17.0502C20.4608 18.3222 20.4492 19.5922 20.439 20.8642Z",
    fill: "#FDB86D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentV2);
export default __webpack_public_path__ + "static/media/document-v2.e067215d6bab37918fff215eab75ed3b.svg";
export { ForwardRef as ReactComponent };